import { NameBox } from './NameBox';

export function FormulaBar() {
  return (
    <div className="flex px-2 pb-4">
      <NameBox />
    </div>
  );
}
